/**
 *
 * @class AbstractProjectElement
 *
 * Base class that allows us to handle something that is ProjectElement'ish, without being
 * specific about which element exactly.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class AbstractProjectElement {

  constructor() {

  }
}

